
import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "axios";
import Constants from "@/constants";
import CommonUtils from "@/common-utils";
import firebase from "firebase/app";
import { MstMemberVO } from "@/views/biz/join/vo/join.vo";

declare type LoginForm = {
  id: string;
  password: string;
  loginType: string;
  appleUser: object;
};

@Component
export default class Login extends Vue {
  loginForm = { loginType: "id" } as LoginForm;
  isLoaded = false; // SNS버튼 한번만..
  refreshEnabled = false;
  interval;

  // computed
  get loginSuccessRouterName(): string {
    return this.$route.params.toName || "Main"; // @Prop 으로 못가져옴
  }

  // method
  loginWithId(): void {
    if (!this.loginForm.id) {
      this.$toast(this.$t("login.a0006")); // 아이디를 입력해 주세요
      return;
    }
    if (!this.loginForm.password) {
      this.$toast(this.$t("login.a0007")); // 비밀번호를 입력해 주세요
      return;
    }
    Axios.post("/login", this.loginForm).then(() => this.onLoginSuccess());
  }

  //로컬스토리지 fromUrl 저장 메소드
  setLocalStorage(): void {
    const queryFromUrl = this.$route.query.fromUrl as string;
    if (queryFromUrl !== "/member/sign-up/1") {
      localStorage.setItem(Constants.STORED_URL_FOR_REDIRECT, queryFromUrl);
    }
  }

  //지쿠 회원가입페이지 이동 메소드(로컬스토리지 fromUrl 저장 메소드 포함)
  goToSignUp(): void {
    this.setLocalStorage();
    this.$router.push({ name: "SignUp1" });
  }

  // 카카오, 애플 로그인
  loginWith(provider: string): void {
    // SNS버튼 한번만..(빠르게 누르면 앱 첫 로그인 포인트 여러번 지급됨. 급하게 막음)
    if (this.isLoaded == true) {
      return;
    }

    this.isLoaded = true;
    this.setLocalStorage();
    const userAgent = navigator.userAgent.toLowerCase();
    if (
      window["ReactNativeWebView"] &&
      userAgent.indexOf("iphone") > -1 &&
      provider == "apple"
    ) {
      window["webViewBridge"].send("appleLogin", {}, this.callbackAppleLogin);
    } else {
      const url = process.env.VUE_APP_BASE_URL_API + `/oauth2/authorization/${provider}`;
       //const url =  process.env.VUE_APP_BASE_URL_API + `/login/oauth2/code/kakao`;
       location.href = url;

    }
  }

  //네이티브 애플로그인 callback
  callbackAppleLogin(result: any): void {
    const params = { appleUser: result, loginType: "appSns" };

    Axios.post("/login", params).then(() => {
      this.onLoginSuccess();
    });
  }

  onLoginSuccess(): void {
    // 첫로그인인지 확인해서 포인트 지급
    Axios.post("/login/first/point").then(()=>{
      return;
    })
    // 로그인 세션
    CommonUtils.setMemberInfoToSession().then((r) => {
      CommonUtils.sendCommonEventLogs(
        this,
        firebase.analytics.EventName.LOGIN,
        { method: "" }
      );
      sessionStorage.setItem(Constants.SESSION_LOGIN, "1");
      this.$store.commit("touchKeepAlive");
      if (window["ReactNativeWebView"]) {
        window["webViewBridge"].send("sessionChange", {}, null);
      }

      // 추천인정보
      // 애플은 추천인 정보를 넣을 수 없어서...
      const refId = CommonUtils.getLocalStorageObject(
        Constants.EXTERNAL_PARAM_REF_ID
      );
      const refMemCd =
        CommonUtils.getLocalStorageObject(
          Constants.EXTERNAL_PARAM_REF_MEM_CD
        ) || 0;

      const memberInfo = this.$session.get(Constants.MEMBER_INFO);
      const isApple = memberInfo.loginType == "14";

      if (!refId || !isApple) {
        this.next();
        return;
      }

      // 애플만
      // 추천인 정보 저장
      Axios.put("/join/validation/referrer", {
        refMemId: refId,
        refMemCd: refMemCd,
      }).finally(() => {
        // 까알끔하게 지워준다.
        CommonUtils.removeLocalStorageObject(Constants.EXTERNAL_PARAM_REF_ID);
        CommonUtils.removeLocalStorageObject(
          Constants.EXTERNAL_PARAM_REF_MEM_CD
        );
        this.next();
      });
    });
  }

  onApiSuccess(): void {
    Axios.get("/login/ping").then((r) => {
      if (r.data == "pong") {
        this.onLoginSuccess();
      } else {
        this.$router.push({ name: "LinkSns" });
      }
    });
  }

  // 모든 것이 완료
  next() {
    if (localStorage.getItem(Constants.STORED_URL_FOR_REDIRECT)) {
      this.$router.push({
        path: localStorage.getItem(Constants.STORED_URL_FOR_REDIRECT)!,
      });
      localStorage.removeItem(Constants.STORED_URL_FOR_REDIRECT);
    } else if (
      this.loginSuccessRouterName &&
      this.loginSuccessRouterName != "Login"
    ) {
      this.$router.push({
        name: this.loginSuccessRouterName,
        params: this.$route.params,
      });
    }

    this.isLoaded = false;
  }

  startPingCheck(){
    this.interval = setInterval(() =>{
      try{
        Axios.get("/login/ping").then((r)=>{
          if(r.data =="pong" || this.$route.query.success){
            clearInterval(this.interval);
            this.interval = null;
            this.$router.push({ name: "Login" });

          }
        })
      }catch(e){
        
      }
    },1000);
  }

  created() {
    if(this.$route.query.status == 'waiting'){
      this.startPingCheck();
    }else{
    this.$route.query.success && this.onApiSuccess();
    this.refreshEnabled = true;
    this.isPullToRefreshEnabled(false);
    clearInterval(this.interval);
    }

  }

  // 로그인 -> 회원가입 이동 빼고 로컬스토리지 url 삭제
  // 이유 : 회원가입 후 로그인에 왔을시 "ZIKOO" 클릭하여 메인으로 갈 수 있어서
  destroyed() {
    if (
      localStorage.getItem(Constants.STORED_URL_FOR_REDIRECT) &&
      this.$route.name !== "SignUp1"
    ) {
      localStorage.removeItem(Constants.STORED_URL_FOR_REDIRECT);
    }
    if (this.refreshEnabled) {
      this.refreshEnabled = false;
      this.isPullToRefreshEnabled(true);
    }
  }

  isPullToRefreshEnabled = (type: boolean) => {
    if (this.$isMobile) {
      if (window["webViewBridge"]) {
        const { send } = window["webViewBridge"];
        send("refresh", { type });
      }
    }
  };
}
